import { defineComponent as _defineComponent } from 'vue'
import { ref, computed } from 'vue';
import { TipsDialog } from '@tencent/wphk-act-base-ui';
import { language } from '@tencent/ppd-base-libs';
import { useGlobalBi } from '@/hooks/use-global-bi';


export default /*#__PURE__*/_defineComponent({
  __name: 'wallet-guide',
  props: {
  isShow: {
    type: Boolean,
    default: false,
  },
},
  setup(__props) {

const props = __props



const { getBiExt } = useGlobalBi();


const tipsDialog = ref();

const isShowTip = ref(props.isShow);

const guideImgs = [
  'https://st.moneydata.hk/res/uploadcdn-static/hkwallet/general/20231221163829/c1.png',
  'https://st.moneydata.hk/res/uploadcdn-static/hkwallet/general/20231221163829/c2.png',
  'https://st.moneydata.hk/res/uploadcdn-static/hkwallet/general/20231221163829/c3.png',
];
const enGuideImgs = [
  'https://st.moneydata.hk/res/uploadcdn-static/hkwallet/general/20231221163829/e1.png',
  'https://st.moneydata.hk/res/uploadcdn-static/hkwallet/general/20231221163829/e2.png',
  'https://st.moneydata.hk/res/uploadcdn-static/hkwallet/general/20231221163829/e3.png',
];

const imgs = computed(() => (language.isEn() ? enGuideImgs : guideImgs));

function showGuideDialog() {
  isShowTip.value = false;
  tipsDialog.value.showDialog();
}

function handleClose() {
  isShowTip.value = true;
}


return { __sfc: true,props, getBiExt, tipsDialog, isShowTip, guideImgs, enGuideImgs, imgs, showGuideDialog, handleClose, TipsDialog }
}

})